module.exports = __webpack_public_path__ + "static/media/magpieBanner_sm2.b8779095.png";